import http from '../../api/Http';
import { IResponse } from '../../api/interfaces';
import { IDemandListStatistics } from './interfaces';

/**
 * 当前需求清单统计
 * @param countryCode
 * @returns
 */
export const getDemandListStatistics = (
  countryCode: string,
): Promise<IResponse<IDemandListStatistics>> => {
  return http.post(`/customer-web/customer/query/demand-list/product/statistics`, { countryCode });
};
